import * as THREE from 'three';
import { PlanogramBlocking } from "./PlanogramBlocking.js"
import { PlanogramRenderer } from "./PlanogramRenderer.js";

export class PlanogramBlockingDivider extends HTMLElement {
    static attributes = {
        X: 'x',
        Y: 'y',
        Length: 'length',
        Direction: 'direction',
        Selected: 'selected'
    }
    static get observedAttributes(){
        return [ ...Object.values(PlanogramBlockingDivider.attributes) ];
    }

    static DIVIDER_LENGTH = 1.5;

    /**@type {PlanogramBlocking} */
    #parentBlocking = null;
    firstRender = true;

    get x() { return Number(this.getAttribute(PlanogramBlockingDivider.attributes.X)) || 0; }
    get y() { return Number(this.getAttribute(PlanogramBlockingDivider.attributes.Y)) || 0; }
    get length() { return Number(this.getAttribute(PlanogramBlockingDivider.attributes.Length)) || 0; }
    get direction() { return this.getAttribute(PlanogramBlockingDivider.attributes.Direction) }
    get selected() { return this.hasAttribute(PlanogramBlockingDivider.attributes.Selected); }

    get group(){  return this.#parentBlocking?.group; }

    constructor(){
        super();
    }

    raiseClickEvent( x, y, rightClick = false ){
        const renderer = PlanogramRenderer.get(this);
        const rect = renderer.domElement.getBoundingClientRect();
        const clickEvent = new MouseEvent( "click", { bubbles: true, cancelable: true, view: window, clientX: rect.x + x, clientY: rect.y + y });
        Object.defineProperty(clickEvent, 'button', { ...Object.getOwnPropertyDescriptor(clickEvent, 'button'), get: function() {return rightClick ? 2 : 0;}});
        Object.defineProperty(clickEvent, 'target', { ...Object.getOwnPropertyDescriptor(clickEvent, 'target'), get: (function() {return this;}).bind(this)});
        if( this.dispatchEvent(clickEvent) && renderer.showMessages ){
            console.groupCollapsed("PlanogramBlockingDivider Selected" + (rightClick? " and Context Menu":""));
            console.log("Target: ", this);
            console.log("Event: ", clickEvent);
            console.groupEnd();
        }
    }

    raiseMoveEvent( x, y ){
        const renderer = PlanogramRenderer.get(this);
        const moveEvent = new MouseEvent( "dblclick", { bubbles: true, cancelable: true, view: window, clientX: x, clientY: y });
        Object.defineProperty(moveEvent, 'target', { ...Object.getOwnPropertyDescriptor(moveEvent, 'target'), get: (function() {return this;}).bind(this)});
        if( this.dispatchEvent(moveEvent) && renderer.showMessages ){
            console.groupCollapsed("PlanogramBlockingDivider Moved");
            console.log("Target: ", this);
            console.log("Event: ", moveEvent);
            console.groupEnd();
        }
    }

    /**
     * 
     * @param {THREE.Vector3} planSize 
     * @param {boolean} preview 
     * @returns {THREE.Vector3}
     */
    getDimensions(planSize, preview = false){
        var newDimensions = new THREE.Vector3();
        const dividerlength = preview ? 1 : PlanogramBlockingDivider.DIVIDER_LENGTH;
        if(this.direction === "horizontal"){
            newDimensions.set(this.length * planSize.x, dividerlength, planSize.z);
        }else{
            newDimensions.set(dividerlength, this.length * planSize.y, planSize.z);
        }
        return newDimensions;
    }

    /**
     * 
     * @param {THREE.Vector3} planSize 
     * @returns {THREE.Vector3}
     */
    getPosition(planSize){
        var newCoordinate = new THREE.Vector3();
        if(this.direction === "horizontal"){
            newCoordinate.set((this.x * planSize.x) + (this.length * planSize.x / 2), (this.y * planSize.y), planSize.z/2);
        }
        else{
            newCoordinate.set((this.x * planSize.x), (this.y * planSize.y) + (this.length * planSize.y / 2), planSize.z/2);
        }
        return newCoordinate;
    }

    /**
     * 
     * @returns {THREE.Vector4}
     */
    getOptions(){
        return new THREE.Vector4( 0x000000, this.selected ? 1 : 0, 3, 2);
    }

    connectedCallback() {
        if(this.parentElement instanceof PlanogramBlocking ){
            this.#parentBlocking = this.parentElement;
            this.firstRender = false;
            this.#parentBlocking.updateMeshes();
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.firstRender || oldValue === newValue ) return;
        this.#parentBlocking?.updateMeshes();
    }

    disconnectedCallback() {
        this.#parentBlocking?.updateMeshes();
    }

}